var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMealsNot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8977 13.4993C21.6932 13.2947 21.4886 13.1584 21.2841 13.1584C21.0114 8.1811 17.0568 4.15838 12.1477 3.81747V2.99929C12.5568 2.79474 12.8295 2.31747 12.8295 1.8402C12.8295 1.0902 12.2159 0.476562 11.4659 0.476562C10.7159 0.476562 10.1023 1.0902 10.1023 1.8402C10.1023 2.31747 10.375 2.72656 10.7159 2.99929V3.88565C5.875 4.15838 1.92045 8.1811 1.64773 13.1584C1.44318 13.1584 1.17045 13.2947 1.10227 13.4993C0.965909 13.7038 0.965909 13.9766 1.10227 14.1811L1.78409 15.3402C2.05682 15.8175 2.53409 16.5675 3.69318 16.5675H19.3068C20.4659 16.5675 20.875 15.8175 21.2159 15.3402L21.8977 14.1811C22.0341 13.9766 22.0341 13.7038 21.8977 13.4993ZM11.4659 5.18111C15.9659 5.18111 19.6477 8.72656 19.9205 13.1584H3.01136C3.28409 8.72656 6.96591 5.18111 11.4659 5.18111ZM19.9886 14.6584C19.7159 15.1356 19.5795 15.2038 19.2386 15.2038H3.69318C3.35227 15.2038 3.28409 15.0675 3.01136 14.6584L2.875 14.522H20.0568L19.9886 14.6584Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 17.4628,
    x2: 17.4393,
    y2: 2.52344,
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealsNot);
export default __webpack_public_path__ + "static/media/meals_not.30e632b28869f640ae28c9fe38237ca9.svg";
export { ForwardRef as ReactComponent };